/**
 * @name modules
 * @description モジュールの実行
 * @param {Object} lenis Lenisインスタンス
 */

//import modules
import { setLoading } from "./setLoading";
import { setSmoothScroll } from "./setSmoothScroll";
import { setCreateSpan } from "./setCreateSpan";
import { setDrawerButton } from "./setDrawerButton";
import { setScrollTrigger } from "./setScrollTrigger";

/**
 * @name addModule
 * @description モジュールの追加
 */
function addModule() {

  const html = document.documentElement;
  const header = document.querySelector('.header');

  /**
   * @name __setScrollPaddingTop
   * @description アンカーリンク先に”scroll-padding-top”を設定する
   */
  function __setScrollPaddingTop() {
    const init = () => {
      let headerHeight = header.clientHeight;
      html.style.scrollPaddingTop = `${headerHeight}px`;
    }
    init();
    window.addEventListener("resize", init);
  }

  /**
   * @name __hoverEffect
   * @description ホバーエフェクトに関する処理
   */
  const __hoverEffect = () => {
    const hoverTargets = document.querySelectorAll('.--js-hover-target');

    // マウスオーバー時のプロパティを設定
    const setPropaty = (item, top) => item.style.translate = `0 ${top}px`;

    // マウスオーバー時の処理
    hoverTargets.forEach((target) => target.addEventListener('mouseenter', (e) => {
      let effect = e.target.parentNode.parentNode.querySelector('[class*="-effect"]');
      setPropaty(effect, e.target.offsetTop)
    }));
  }

  /**
   * @name __drawerNav
   * @description ドロワーナビゲーションに関する処理
   */
  const __drawerNav = () => {
    const drawerNav = document.querySelector('.drawerNav');

    // ドロワーナビゲーションのスクロールを無効化
    drawerNav.addEventListener('wheel', (e) => e.stopPropagation(), { passive: false })
    drawerNav.addEventListener('touchmove', (e) => e.stopPropagation(), { passive: false })
  }

  /**
   * @name __serviceLinks
   * @description サービスのリンクに関する処理
   */
  const __serviceLinks = () => {
    const serviceLinksItems = document.querySelectorAll('.service-links__item');
    const serviceLinksBgImgs = document.querySelectorAll('.service-links-bg__img');

    // 背景画像の表示・非表示を切り替える
    const showToggle = (state, el) => {
      state ? el.classList.add('--show') : el.classList.remove('--show');
    }

    // マウスオーバー時の処理
    const hoverFunc = (item, state, img) => {
      item.addEventListener('mouseenter', () => showToggle(state, img));
      item.addEventListener('mouseleave', () => showToggle(!state, img));
    }

    // スクロール時の処理
    const scrollFunc = (item, state, img) => {
      const rect = item.getBoundingClientRect();
      rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2 ? showToggle(state, img) : showToggle(!state, img);
    }

    // サービスのリンクにマウスオーバーした際の処理
    serviceLinksItems.forEach((item, index) => hoverFunc(item, true, serviceLinksBgImgs[index]));

    // スクロール時に特定の位置に応じて背景画像の表示・非表示を切り替える
    //spのみ
    window.addEventListener('scroll', () => {
      if (window.innerWidth > 835) return;
      serviceLinksItems.forEach((item, index) => scrollFunc(item, true, serviceLinksBgImgs[index]))
    });
  }

  /**
   * @name __pointItems
   * @description 「ヨシダ住建の強み」ページのポイント一覧に関する処理
   */
  const __pointItems = () => {
    const serviceLinksItems = document.querySelectorAll('.point-list__item');
    const serviceLinksBgImgs = document.querySelectorAll('.point-list-bg__img');

    // 背景画像の表示・非表示を切り替える
    const showToggle = (state, el) => {
      state ? el.classList.add('--show') : el.classList.remove('--show');
    }

    // スクロール時の処理
    const scrollFunc = (item, state, img) => {
      const rect = item.getBoundingClientRect();
      rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2 ? showToggle(state, img) : showToggle(!state, img);
    }

    // スクロール時に特定の位置に応じて背景画像の表示・非表示を切り替える
    window.addEventListener('scroll', () => {
      serviceLinksItems.forEach((item, index) => scrollFunc(item, true, serviceLinksBgImgs[index]))
    });
  }

  /**
   * @name __galleryToggle
   * @description ギャラリーの表示切り替えに関する処理
   */
  const __galleryToggle = () => {
    const galleryCurrentImages = document.querySelectorAll('.gallery__current img');
    const galleryThumbnailImages = document.querySelectorAll('.gallery__thumbnail img');
    if (!galleryCurrentImages) return;

    let className = "current";

    /**
     * @name galleryInit
     * @description ギャラリーの表示切り替え
     */
    const galleryInit = (el) => {
      let currentItem = el.currentTarget;
      let getNum = currentItem.dataset.number;

      //選択した要素以外に対しての処理
      galleryThumbnailImages.forEach((image) => image.classList.remove(className));

      //選択した要素に対しての処理
      currentItem.classList.add(className);

      //選択した要素から取得したnumber属性を元に、メインギャラリーの表示切り替え
      galleryCurrentImages.forEach((image) => {
        image.dataset.number === getNum ? image.classList.add(className) : image.classList.remove(className);
      })
    }

    //クリック時の処理
    galleryThumbnailImages.forEach((image) => image.addEventListener('click', (clickEl) => galleryInit(clickEl)))
  }

  /**
   * @name __selectToggle
   * @description selectタグを更新後、.selectedを付与
   */
  const __selectToggle = () => {
    const select = document.querySelector('select[name="your-select"]');
    if (!select) return;
    select.addEventListener('change', (e) => e.target.value !== "" ? select.classList.add('selected') : select.classList.remove('selected'))
  }

  /**
   * @name __scrollTransform
   * @description スクロール時に関する処理
   */
  const __scrollTransform = () => {

    let sc = (function () {
      let scrollElement = 'scrollingElement' in document ? document.scrollingElement : document.documentElement;
      let scrollPoint, prePoint, flag;
      return function () {
        scrollPoint = scrollElement.scrollTop;
        flag = prePoint > scrollPoint ? true : false;
        prePoint = scrollPoint;
        return flag;
      }
    })();

    const init = () => {
      sc() ? html.classList.remove('nav-hidden') : html.classList.add('nav-hidden');
    }
    window.addEventListener("scroll", () => init());
  }

  __setScrollPaddingTop();
  __hoverEffect();
  __drawerNav();
  __serviceLinks();
  __pointItems();
  __galleryToggle();
  __selectToggle();
  __scrollTransform();
}

//modules
export function modules(lenis) {
  setLoading(lenis)
  setSmoothScroll(lenis)
  setCreateSpan();
  setDrawerButton(lenis);
  setScrollTrigger();
  addModule();
}